import moment from 'moment';

export const formatDateSimple = (date) => moment().format('L');

export const formatDateLong = (date) => {
  const d = moment(date);
  const today = moment();
  if (d.year() === today.year()) {
    return d.format('MMM DD, hh:mma');
  } else {
    return d.format('MMM DD, YYYY');
  }
};

export const formatDateFromNow = (date) => moment(date).fromNow();
